// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"2b923fca","247":"9a06c14f","583":"69bf0d54","710":"f663538b","878":"b4ebd04a","983":"5487ea44"}[chunkId] + ".chunk.js";
};